var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Comment", {
        attrs: {
          comment: _vm.comment,
          "show-actions": ["resolve", "edit", "delete"],
          "current-user-id": _vm.currentUserId,
          "users-data": _vm.usersData,
        },
        on: {
          resolveComment: function ($event) {
            return _vm.resolveComment()
          },
          editComment: function ($event) {
            return _vm.editComment(_vm.comment.id, null, $event)
          },
          deleteComment: function ($event) {
            return _vm.deleteComment(_vm.comment.id)
          },
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.comment.reply, function (r) {
        return _c(
          "div",
          { key: r.id, staticClass: "reply col-12" },
          [
            _c("Comment", {
              attrs: {
                comment: r,
                "show-actions": ["edit", "delete"],
                "current-user-id": _vm.currentUserId,
                "users-data": _vm.usersData,
              },
              on: {
                editComment: function ($event) {
                  return _vm.editComment(_vm.comment.id, r.id, $event)
                },
                deleteComment: function ($event) {
                  return _vm.deleteComment(_vm.comment.id, r.id)
                },
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.showInput
        ? _c("div", { staticClass: "row reply-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputVmodel,
                  expression: "inputVmodel",
                },
              ],
              staticClass: "reply-input col",
              attrs: { placeholder: "Add Reply Here ..." },
              domProps: { value: _vm.inputVmodel },
              on: {
                keydown: _vm.enterToReply,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.inputVmodel = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "reply-send col-1",
                attrs: { disabled: !_vm.inputVmodel },
                on: { click: _vm.replyComment },
              },
              [
                _c("i", {
                  staticClass: "v-icon mdi mdi-send",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }